import { useNavigate } from "react-router-dom";
import { FiShoppingBag } from "../../../icons";
import "../../../Styles/CartPopup.css";

interface ISingleCartProductProps {
  productID: number;
  productName: string;
  productMaterial: string;
  productPrice: number;
  productImage: string;
  productAmount: number;
}

const SingleCartProduct = ({
  productID,
  productName,
  productMaterial,
  productPrice,
  productImage,
  productAmount,
}: ISingleCartProductProps): JSX.Element => {
  const navigate = useNavigate();

  return (
    <div
      className="mini-cart-item"
      onClick={() => {
        navigate(`/products/${productID}`);
      }}
    >
      <img
        className="mini-cart-item-image"
        src={`https://jewelryshopdoro.com/uploads/${productImage}`}
        alt={productName}
      />
      <div className="mini-cart-item-info">
        <span className="mini-cart-item-name">
          {productName} - {productMaterial}
        </span>
        <span className="mini-cart-item-price">
          {`${productAmount} × ${productPrice} rsd = `}
          <span className="mini-cart-item-total">
            {`${(productPrice * productAmount).toFixed(2)} rsd`}
          </span>
        </span>
      </div>
    </div>
  );
};

interface CartPopupProps {
  handleOpenCart: () => void;
}

const CartPopup: React.FC<CartPopupProps> = ({ handleOpenCart }) => {
  const navigate = useNavigate();
  const cartProductsString = sessionStorage.getItem("products");
  let cartProducts;

  if (cartProductsString != null) cartProducts = JSON.parse(cartProductsString);
  else cartProducts = [];

  if (cartProducts.length > 0) {
    let totalOrderPrice = 0.0;
    for (let singleCartProduct of cartProducts) {
      totalOrderPrice += singleCartProduct.price * singleCartProduct.amount;
    }

    return (
      <div className="mini-cart">
        <div className="mini-cart-list">
          {cartProducts.map((singleCartProduct: any, index: number) => (
            <SingleCartProduct
              key={index}
              productName={singleCartProduct.product_name}
              productMaterial={singleCartProduct.material}
              productPrice={singleCartProduct.price}
              productImage={singleCartProduct.main_image}
              productAmount={singleCartProduct.amount}
              productID={singleCartProduct.id}
            />
          ))}
        </div>
        <div className="mini-cart-footer">
          <div className="mini-cart-total-row">
            <span className="mini-cart-total-label">Ukupno:</span>
            <span className="mini-cart-total-value">
              {`${totalOrderPrice.toFixed(2)} rsd`}
            </span>
          </div>
          <button
            type="button"
            className="mini-cart-btn"
            onClick={() => {
              navigate("/cart");
              handleOpenCart();
            }}
          >
            Vaša korpa
          </button>
        </div>
      </div>
    );
  } else {
    return (
      <div className="mini-cart">
        <div className="mini-cart-empty">
          <FiShoppingBag className="mini-cart-empty-icon" />
          <h2 className="mini-cart-empty-title">Vaša korpa je prazna</h2>
          <button
            type="button"
            className="mini-cart-empty-btn"
            onClick={() => {
              navigate("/products");
              handleOpenCart();
            }}
          >
            Nastavite kupovinu
          </button>
        </div>
      </div>
    );
  }
};

export default CartPopup;
